/* taio-xsell: dodanie produktu polecanego do koszyka bez przeładowania strony.
   Logika odświeżenia szuflady przeniesiona ze starego snippetu xsell-widget,
   który działał na karcie oleju z sardeli: cart-drawer albo cart-notification Dawn,
   a gdy żadnego nie ma, zdarzenie cart:refresh. */
(function () {
  'use strict';

  if (window.taioXsellGotowy) return;
  window.taioXsellGotowy = true;

  function koszyk() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function napis(btn, tekst) {
    var el = btn.querySelector('[data-taio-xsell-napis]');
    if (el) el.textContent = tekst;
  }

  function przywroc(btn, poMs) {
    setTimeout(function () {
      btn.classList.remove('is-dodany');
      napis(btn, btn.dataset.tekst || 'Dodaj');
      btn.disabled = false;
    }, poMs);
  }

  /* Jeden błysk światła przez kartę, gdy pierwszy raz wjeżdża w ekran. */
  function obserwuj() {
    var karty = document.querySelectorAll('[data-taio-xsell-karta]:not(.is-widoczny)');
    if (!karty.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (wpisy) {
      wpisy.forEach(function (w) {
        if (w.isIntersecting) {
          w.target.classList.add('is-widoczny');
          io.unobserve(w.target);
        }
      });
    }, { threshold: 0.6 });
    karty.forEach(function (k) { io.observe(k); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', obserwuj);
  } else {
    obserwuj();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-taio-xsell]');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    napis(btn, 'Dodaję');

    var k = koszyk();
    var tresc = {
      items: [{
        id: Number(btn.dataset.wariant),
        quantity: 1,
        properties: { _zrodlo: btn.dataset.zrodlo || 'cross-sell' }
      }]
    };

    if (k && typeof k.getSectionsToRender === 'function') {
      tresc.sections = k.getSectionsToRender().map(function (s) { return s.id; });
      tresc.sections_url = window.location.pathname;
      if (typeof k.setActiveElement === 'function') k.setActiveElement(btn);
    }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(tresc)
    })
      .then(function (odp) { return odp.json(); })
      .then(function (odp) {
        if (odp.status) throw new Error(odp.description || 'blad-dodania');

        btn.classList.add('is-dodany');
        napis(btn, 'Dodano');

        if (k && typeof k.renderContents === 'function') {
          var szuflada = document.querySelector('cart-drawer');
          if (szuflada) szuflada.classList.remove('is-empty');
          k.renderContents(odp);
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }

        przywroc(btn, 2200);
      })
      .catch(function () {
        napis(btn, 'Spróbuj jeszcze raz');
        przywroc(btn, 2500);
      });
  });
})();
